/** Emojis wie Dashboard-Schnellzugriff (einheitlich in Listen & Zähler-Leisten). */
export const PROJEKT_TYP_EMOJI = {
  elektro: "⚡",
  pv: "🔋",
  sicherheit: "🛡️",
  ladestation: "🔌",
  intern: "🏠",
  ladenbau: "🛍️",
};

export const PROJEKT_TYP_LABEL = {
  elektro: "Elektro",
  pv: "PV",
  sicherheit: "Sicherheit",
  ladestation: "Ladestation",
  intern: "Intern",
  ladenbau: "Ladenbau",
};

export const SERVICE_AUFTRAG_EMOJI = "🛠️";
export const SERVICE_AUFTRAG_LABEL = "Service";

export const WARTUNG_VERTRAG_EMOJI = "🧰";
export const WARTUNG_VERTRAG_LABEL = "Wartung";

export const OFFERTE_EMOJI = "📄";
export const OFFERTE_LABEL = "Offerte";

export const ARCHIV_EMOJI = "🗃️";

export const MAENGEL_EMOJI = "📝";
export const GARANTIE_FALLTYP_EMOJI = "🛡️";

/** Archiv-/Listen-Bereichs-Chips (Tab `kind` + `key`) */
export function emojiForArchivTab(tab) {
  if (!tab || tab.kind === "alle") return null;
  if (tab.kind === "projekt") return emojiForProjektTyp(tab.key);
  if (tab.kind === "maengel") return MAENGEL_EMOJI;
  if (tab.kind === "service") return SERVICE_AUFTRAG_EMOJI;
  return null;
}

export function projektTypFromCountKey(key) {
  return String(key || "").replace(/^projekte_/, "");
}

export function emojiForProjektTyp(typ) {
  return PROJEKT_TYP_EMOJI[String(typ || "").toLowerCase()] || "📁";
}

export function labelForProjektTyp(typ) {
  return PROJEKT_TYP_LABEL[String(typ || "").toLowerCase()] || typ || "Projekt";
}
